import React, { useState } from 'react';
import SectionHeader from '../SectionHeader/SectionHeader';
import { FaGithub, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { validateTextInput, validateEmail, validateContactForm } from '../../utils/contactFormValidators';
import config from '../../config';
import './contact-form.css';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [errors, setErrors] = useState({});
    const [responseMessage, setResponseMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Update form data
        setFormData({
            ...formData,
            [name]: value
        });

        setErrors((prevErrors) => {
            if (name === 'name' || name === 'message') {
                const error = validateTextInput(value, 'Field');
                if (error) {
                    return {
                        ...prevErrors,
                        [name]: error,
                    };
                } else {
                    const { [name]: _, ...rest } = prevErrors;
                    return rest;
                }
            }

            if (name === 'email') {
                const error = validateEmail(value);
                if (error) {
                    return {
                        ...prevErrors,
                        [name]: error,
                    };
                } else {
                    const { [name]: _, ...rest } = prevErrors;
                    return rest;
                }
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (Object.entries(errors).length > 0) {
            setResponseMessage('There are active errors.  Please correct before sumbmitting.');
            return;
        }

        const valErrors = validateContactForm(formData);
        if (Object.entries(valErrors).length > 0) {
            return;
        }

        // If no errors, proceed with form submission using EmailJS
        try {
		      const response = await fetch(`${config.apiUrl}/api/send-email`, {
		        method: 'POST',
		        headers: {
		          'Content-Type': 'application/json',
		        },
		        body: JSON.stringify(formData),
	      });

	      if (response.ok) {
	        setResponseMessage('Your message was sent successfully!');
	        setFormData({
	          name: '',
	          email: '',
	          message: ''
	        });
	        setErrors({});
	      } else {
	        setResponseMessage('Failed to send message.');
	      }
	    } catch (error) {
		      console.error('Failed to send message:', error);
		      setResponseMessage('Failed to send message.');
	    }
    };

    return (
        <div className="box-shadow">
            <SectionHeader name={'Contact'} />

            <div className="section item-container">
            	<p className="small-text">Please use this form to reach out to me with any inquiries.  You can also find me on the social media links listed below.</p>
                  <div className="social-media">
                    <h1>Follow Me</h1>            
                    <a href="https://www.linkedin.com/in/claudiu-dobre-b2419519/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                        <FaLinkedin />
                    </a>
                    <a href="https://www.instagram.com/claudiu1075/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                        <FaInstagram />
                    </a>
                    <a href="https://github.com/Claudiu-DobreO" target="_blank" rel="noopener noreferrer">
							        <FaGithub />
							      </a>   
                </div>
                <form onSubmit={handleSubmit} noValidate>
                    <div className="form-group">
                        <label htmlFor="name"><strong>Name:</strong></label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter your name"
                            required
                            aria-required="true"
                        />
                        {errors.name && <span className="error-text">{errors.name}</span>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="email"><strong>Email:</strong></label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter your email"
                            required
                            aria-required="true"
                        />
                        {errors.email && <span className="error-text">{errors.email}</span>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="message"><strong>Message:</strong></label>
                        <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            rows="5"
                            placeholder="Enter your message"
                            required
                            aria-required="true"
                        ></textarea>
                        {errors.message && <span className="error-text">{errors.message}</span>}
                    </div>
                    <div className="form-group button-container">
                        <button className="button-link-blue" type="submit">Submit</button>
                    </div>
                    {responseMessage && <p>{responseMessage}</p>}
                </form>

            </div>
        </div>
    );
};

export default ContactForm;